import { buttonClasses } from '@crown/ui/button';
import { Card } from '@crown/ui/card';
import { type ActionLink, type DocsCardConfig, isRouteHref } from './page-elements';

export function PillRow({ tags }: { readonly tags: readonly string[] }) @{
  <div class="docs-pill-row">
    @for (const tag of tags; index i; key String(i)) {
      <span class="docs-pill">{tag}</span>
    }
  </div>
}

function ActionLinkButton({ action }: { readonly action: ActionLink }) @{
  @if (action.newTab) {
    <a class={buttonClasses({ variant: action.variant ?? 'outline-secondary' })} href={action.href} target="_blank" rel="noopener noreferrer">{action.label}<span class="docs-visually-hidden"> (opens in a new tab)</span></a>
  } @else {
    <a class={buttonClasses({ variant: action.variant ?? 'outline-secondary' })} href={action.href} data-route-link={isRouteHref(action.href) ? 'true' : null}>{action.label}</a>
  }
}

export function ActionRow({ actions }: { readonly actions: readonly ActionLink[] }) @{
  <div class="docs-button-row">
    @for (const action of actions; index i; key String(i)) {
      <ActionLinkButton action={action} />
    }
  </div>
}

export function DocsCard({ eyebrow, title, description, tags, actions }: DocsCardConfig) @{
  <>{Card({
    title: <div class="docs-card-heading">
      @if (eyebrow) {
        <span class="docs-card-eyebrow">{eyebrow}</span>
      }
      <PillRow tags={tags} />
      <h3>{title}</h3>
    </div>,
    content: <p class="docs-card-copy">{description}</p>,
    footer: <ActionRow actions={actions} />,
    extraClasses: ['docs-card'],
  })}</>
}
